import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import {mapActions, mapState} from 'vuex'
// import dateUtils from '../../../../common/utils/dateUtil'
import moment from 'moment'

export default {
  data () {
    return {
      typeName: '全部',
      pageNum: 1,
      pageSize: 999,
      centerHeight: document.documentElement.clientHeight - 180 +'px',
      points: '',
      grandTotalPoints: '',
      levelName: ''
    }
  },
  computed: {
    ...mapState('rankEquityModule', ['rankEquityList']),
    rankEquityListInfo () {
      return this.rankEquityList
    }
  },
  methods: {
    ...mapActions('rankEquityModule', ['getRankEquityList']),
    goBack (item) {
      this.$router.push({
        path: RoutePathConstants.RANK_EQUITY,
        query: {
        }
      })
    },
    dateFormat (time) {
      return time ? moment(time).format('YYYY/MM/DD') : ''
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    changeTitleType (type) {
      this.typeName = type
    },
    getRankEquityListInfo () {
      let pageData = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,

      }
      this.getRankEquityList(pageData)
    },
    openMoreEquity () {
      this.$router.push({
        path: RoutePathConstants.WX_PERSONAL_CENTER,
        query: {
        }
      })
    }
  },
  mounted () {
    this.getRankEquityListInfo()
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/rank-equity/views/rank-equity-details.js